function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMovable = function SvgMovable(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 20,
    r: 20,
    style: {
      fill: "#1b053a",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 100,
    r: 20,
    style: {
      fill: "#1b053a",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 180,
    r: 20,
    style: {
      fill: "#1b053a",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 140,
    cy: 20,
    r: 20,
    style: {
      fill: "#1b053a",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 140,
    cy: 100,
    r: 20,
    style: {
      fill: "#1b053a",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 140,
    cy: 180,
    r: 20,
    style: {
      fill: "#1b053a",
      strokeWidth: 0
    }
  }));
};
export default SvgMovable;